"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RemoveSavedIDState_1 = require("./RemoveSavedIDState");
/** Platform UI Components */
/** CMS */
/** Stylesheets */
require("./RemoveSavedID.scss");
/** LOB Components */
var RemoveSavedIDModal_1 = require("./RemoveSavedIDModal");
var AreYouSureModal_1 = require("./AreYouSureModal");
/** Api, Reporting, Mappers, Request, Response */
var RemoveSavedID = /** @class */ (function (_super) {
    __extends(RemoveSavedID, _super);
    function RemoveSavedID(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeEvents();
        console.log('RemoveSavedIDs start');
        var ids = _this.props.data.savedUserIdHandler.getSavedUserIds();
        var mstate = new RemoveSavedIDState_1.default();
        mstate.savedIds = ids;
        _this.state = mstate;
        return _this;
    }
    RemoveSavedID.prototype.initializeEvents = function () {
        var _this = this;
        this.areYouSureModalEvents = {
            onModalComplete: function (confirmed) {
                console.log("Are you sure closed, confirmed: " + confirmed);
                _this.setState({
                    showAreYouSureModal: false,
                });
                if (confirmed) {
                    _this.removeSavedIds();
                }
                else {
                    _this.setState({
                        idsToDelete: [],
                    });
                }
                _this.props.events.onClose(confirmed);
            },
        };
        this.removeSavedIdModalEvents = {
            onCancel: function () {
                console.log('onCancel');
                // this.setState( {
                //     showIdModal: false,
                // } );
                _this.props.events.onClose(false);
            },
            onContinue: function (selectedIds) {
                console.log('onContine', selectedIds);
                _this.setState({
                    idsToDelete: selectedIds,
                    showAreYouSureModal: true,
                    showIdModal: false,
                });
            },
        };
    };
    RemoveSavedID.prototype.removeSavedIds = function () {
        for (var _i = 0, _a = this.state.idsToDelete; _i < _a.length; _i++) {
            var id = _a[_i];
            this.props.data.savedUserIdHandler.deleteSavedUserId(id);
        }
        this.setState({
            idsToDelete: [],
        });
    };
    RemoveSavedID.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(RemoveSavedIDModal_1.default, { data: {
                    savedIds: this.state.savedIds,
                    show: this.state.showIdModal,
                }, events: this.removeSavedIdModalEvents }),
            React.createElement(AreYouSureModal_1.default, { data: {
                    idsToDelete: this.state.idsToDelete,
                    show: this.state.showAreYouSureModal,
                }, events: this.areYouSureModalEvents })));
    };
    return RemoveSavedID;
}(React.Component));
exports.default = RemoveSavedID;
//# sourceMappingURL=RemoveSavedID.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/RemoveSavedID.js
// module id = 1504
// module chunks = 8